export default {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  routerBasePath: import.meta.env.VITE_PARCEL_ROUTER_BASE_PATH_VIDEO_TAGS,
};
